import {StorageUtils} from 'xmgoing-utils';
import {getHeight, getMarginStyJson, getStyJson, getWidth, setBorderRadiusStyl} from "@/main-page/utils/styleUtils";
import {getElStyJsonObj, getOutElStyJsonObj} from "@/main-page-base/utils/styleSetUtils";
import eventBus from "@/events/eventBus";
import GoingUtils from "@/utils/goingUtils";

interface IStyConfigs{
  styles:any,
  props:any,
  pItem?:any,
  componentKey?:any,
  dataLabel?:string,
  lrPadding?:any,
  propsStyl?:any,
  extStyl?:any,
  innerPropsStyl?:any,
  outExtendProp?:any,
  innerAddProp?:any,
}
const delPaddingSty=function (sty){
  delete sty["paddingLeft"];
  delete sty["paddingRight"];
  delete sty["paddingTop"];
  delete sty["paddingTop"];
}

export function initPxSty(sty,propName,propValue){
  if(propValue==='auto'||(propValue+'').indexOf("%")>=0){
    sty['width']=propValue;
  }else{
    sty['width']=propValue+"px";
  }
}

export function getStyJsonObj(sty,{styles,props,pItem,componentKey,lrPadding=0}:any){
  getStyJson(sty, unref(styles), props,lrPadding);
  if (unref(props)["src"]) {
    sty["background"] = `url(${unref(props)["src"]}) ${parseFloat(styles['xpos'])}px ${parseFloat(styles['ypos'])}px / 100% 100% no-repeat`;
  }

  if (unref(props)["align"]) {
    sty["text-align"] = unref(props)["align"];
  }
  if (unref(pItem) === 'xmRow' || unref(pItem) === 'xmForm' || (unref(componentKey)==="xmButton")) {
    delete sty["paddingLeft"];
    delete sty["paddingRight"];
    delete sty["paddingTop"];
    delete sty["paddingBottom"];
    delete sty["marginLeft"];
    delete sty["marginRight"];
    delete sty["padding"];
    delete sty["marginTop"];
    delete sty["marginBottom"];
  }
}

export function useCtlStyle({styles, props, pItem,
                              componentKey,
                              lrPadding,propsStyl,
                              extStyl,
                              innerPropsStyl,
                              outExtendProp,innerAddProp}:IStyConfigs,pItemType='') {
  // 运行态下直接计算样式，避免computed的响应式开销
  const getColRowStyle = () => {
    const {height,width,maxWidth}=unref(props);
    const sty = {};
    if((height+'').indexOf("%")>0||height==='auto'){
      sty["height"]=height;
    }else{
      sty["height"]=parseFloat(height)+"px";
    }
    if((width+"").indexOf("%")>0||(width+"")==='auto'){
      sty["width"]=width;
    }else{
      sty["width"]=parseFloat((width+""))+"px";
    }
    if((maxWidth+"").indexOf("%")>0||(maxWidth+"")==='auto'){
      sty["maxWidth"]=maxWidth;
    }else{
      sty["maxWidth"]=parseFloat((maxWidth+""))+"px";
    }
    const {backgroundColor}=unref(styles);
    getMarginStyJson(sty, unref(styles));
    setBorderRadiusStyl(sty, unref(styles));
    if(backgroundColor){
      sty['backgroundColor']=backgroundColor;
    }
    return sty;
  };
  const colRowStyle = getColRowStyle();

  //tab容器样式信息
  const getTabStyle = () => {
    const {height,width}=unref(props);
    const sty = {};
    //高设置
    getHeight(sty,height,unref(props).gridDivFlag);
    //宽设置
    getWidth(sty,width);
    if(unref(styles)["backgroundColor"]){
      sty["backgroundColor"]=unref(styles)["backgroundColor"];
    }
    if(unref(styles)["paddingLeft"]){
      sty['paddingLeft']=unref(styles)["paddingLeft"]+'px';
    }
    if(unref(styles)["paddingRight"]){
      sty['paddingRight']=unref(styles)["paddingRight"]+'px';
    }
    return sty;
  };
  const tabStyle = getTabStyle();

  /**
   * 获取组件的样式
   */
  const getCtlStyle = () => {
    const sty = {};
    getStyJsonObj(sty,{styles,props,pItem,componentKey,lrPadding});
    if (GoingUtils.isDesFlag()) {
      nextTick(()=>{
        eventBus.emit('onFlushActiveState', {});
      })
    }
    return sty;
  };
  const ctlStyle = getCtlStyle();

  /**
   * 不要背景色
   */
  const getCtlStyleNoBg = () => {
    const sty = {};
    getStyJsonObj(sty,{styles,props,pItem,componentKey,lrPadding});
    delete sty['background-color'];
    delete sty['backgroundColor'];
    return sty;
  };
  const ctlStyleNoBg = getCtlStyleNoBg();

  const getCtlStyleNoPadding = () => {
    const sty = {};
    getStyJsonObj(sty,{styles,props,pItem,componentKey,lrPadding});
    delete sty["paddingLeft"];
    delete sty["paddingRight"];
    delete sty["paddingTop"];
    delete sty["paddingTop  "];
    return sty;
  };
  const ctlStyleNoPadding = getCtlStyleNoPadding();

  /**
   * 解决边框重复计算的问题
   */
  const getCtlDivStyle = () => {
    const sty = {};
    getStyJsonObj(sty,{styles,props,pItem,componentKey});
    delete sty["border-right"];
    delete sty["border-bottom"];
    delete sty["border-left"];
    // delete sty["border-top"];

    //如果父亲节点就是 外容器div
    if(pItem==='col-body'){
      delete sty["marginLeft"];
      delete sty["marginRight"];
      delete sty["marginTop"];
      delete sty["marginBottom"];
    }
    //直接父亲类型为xmDiv 则不能添加padding 不然会重复
    if(pItemType==='xmDiv'){
      delPaddingSty(sty);
    }

    const {maxWidth}=unref(props);
    if(!(maxWidth==null||maxWidth==='undefined')){
      if((maxWidth+"").indexOf("%")>0||(maxWidth+"")==='auto'){
        sty["maxWidth"]=maxWidth;
      }else{
        sty["maxWidth"]=parseFloat((maxWidth+""))+"px";
      }
    }

    // 检查 extStyl 是否为数组且包含 'padding' 或 'paddingLeft' 字符串
    if(unref(extStyl) && Array.isArray(unref(extStyl))){
      // 如果extStyl数组中包含'padding'或'paddingLeft'字符串，则删除padding相关样式
      const hasPaddingStyle = unref(extStyl).some(item =>
        item === 'padding' || item === 'paddingLeft'
      );
      if (hasPaddingStyle) {
        delPaddingSty(sty);
      }
    }
    return sty;
  };
  const ctlDivStyle = getCtlDivStyle();

  const getCtlNoBackStyle = () => {
    const sty = {};
    getStyJson(sty, unref(styles), props);
    if (unref(props)["align"]) {
      sty["text-align"] = unref(props)["align"];
    }
    if (unref(pItem) === 'xmRow' || unref(pItem) === 'xmForm') {
      delete sty["paddingLeft"];
      delete sty["paddingRight"];
      delete sty["paddingTop"];
      delete sty["marginLeft"];
      delete sty["marginRight"];
      delete sty["marginTop"];
      delete sty["marginBottom"];
    }
    sty["background"] = "";
    return sty;
  };
  const ctlNoBackStyle = getCtlNoBackStyle();


  /**
   * 改变元素的样式
   */
  const changeElSty = function () {
    const desAppFlag = StorageUtils.getSessionItem("desAppFlag");
    if (desAppFlag === 'true') {
      const compEl = document.getElementById(unref(props)._vid);
      const draggableEl: any = compEl?.closest('._slot-item');
      let topHeight = 50;
      if (unref(props).hasSearch) {
        topHeight = topHeight + 50;
      }
      if (unref(props).hasTabBar) {
        topHeight = topHeight + 50;
      }
      draggableEl.style.height = `calc(100% - ${topHeight}px)`;
    }
  }

  const initDefProps = function (defProps={}) {
    //设置默认值
    if (unref(props).showLabel == null) {
      unref(props).showLabel = true;
    }
    if (unref(props).showArrow == null) {
      unref(props).showArrow = true;
    }
    if (unref(props).pageSize == null) {
      unref(props).pageSize = 10;
    }
    if (unref(props).gridSize == null) {
      unref(props).gridSize = 'default';
    }
    if (unref(props).hasSearch == null) {
      unref(props).hasSearch = true;
    }
    if (unref(props).hasPagin == null) {
      unref(props).hasPagin = true;
    }
    if (unref(props).bordered == null) {
      unref(props).bordered = true;
    }
    if(defProps){
      Object.keys(defProps).forEach((propName)=>{
        if (unref(props)[propName] == null) {
          unref(props)[propName] = defProps[propName];
        }
      })
    }
    unref(props).editor = false;
  }

  /**
   * 获取默认提示语言
   */
  const getDefPlaceholder = () => {
    if(unref(componentKey)==='xmTree'){
      return '请选择树节点';
    }else if(unref(componentKey)==='xmSelect'){
      return '请选择'+unref(props).label;
    }else{
      if(unref(props).options){
        return '请选择'+unref(props).label||'';
      }else{
        return '请输入'+unref(props).label||unref(props).propName||'';
      }
    }
  };

  /**
   * 元素外壳样式
   */
  const getElCtlStyle = () => {
    const sty:any = {};
    getOutElStyJsonObj(sty,{styles,props,propsStyl,outExtendProp});
    return sty;
  };
  const elCtlStyle = getElCtlStyle();

  /**
   * 元素内部样式
   */
  const getElBaseStyle = () => {
    const sty = {};
    getElStyJsonObj(sty,{styles,props,innerPropsStyl,innerAddProp});
    return sty;
  };
  const elBaseStyle = getElBaseStyle();

  /**
   * 元素通用sty
   */
  const getFormElComSty = () => {
    return [
      unref(props).remarkWidth?'--remarkWidth:'+unref(props).remarkWidth+'px;':'',
      unref(props).backgroundColor?'--bgColor:'+unref(props).backgroundColor+';':''
    ];
  };
  const formElComSty = getFormElComSty();

  /**
   * 元素通用class
   */
  const getFormElComClass = () => {
    return [
      (unref(props).borderedBottom+'')==='true'?'borderedBottom':'borderedNotBottom',
      (unref(props).readOnlyText+'')==='true'?'readOnlyText':'readOnlyTextNot',
      unref(props).labelPosition,
      unref(props).remarkPosition?'remarkLeft':'',
    ];
  };
  const formElComClass = getFormElComClass();

  const getIsDes = () => {
    if(GoingUtils.isDesFlag()){
      return true;
    }
    return false;
  };
  const isDes = getIsDes();


  const getInputStyle = () => {
    let sty={};
    if(unref(props).inputWidth){
      if(unref(props).inputWidth.indexOf("%")>=0||unref(props).inputWidth==='auto'){
        sty['width']=unref(props).inputWidth;
        return sty;
      }
      sty['width']=unref(props).inputWidth+"px";
    }
    return sty;
  };
  const inputStyle = getInputStyle();

  return {
    inputStyle,
    isDes,
    disabledDrag:false,
    formElComClass,
    formElComSty,
    elCtlStyle,
    elBaseStyle,
    ctlStyleNoPadding,
    ctlDivStyle,
    tabStyle,
    colRowStyle,
    getDefPlaceholder,
    initDefProps,
    ctlNoBackStyle,
    getStyJson,
    changeElSty,
    ctlStyle,
    ctlStyleNoBg
  }
}
